<template>
    <div>

        <!-- search input -->
        <ImageLabel>
            <img class="ph2" src="@/assets/img/icon_search_tools.svg"/>
            <input v-focus.lazy="lg" @keyup.enter="submit" class="flex-auto input-reset bn outline-0" placeholder="Search for tools & equipment" v-model="search" />
        </ImageLabel>

        <!-- location -->
        <ImageLabel class="mt2 mb2">
            <img class="ph2" src="@/assets/img/icon_search_location.svg"/>
            Winnipeg
        </ImageLabel>

        <!-- search button -->
        <TooliabaButton @click="submit">Search for Tools</TooliabaButton>

    </div>
</template>

<script>
import { focus } from 'vue-focus';
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import ImageLabel from '@/components/controls/ImageLabel.vue';

export default {
    directives: { focus: focus },
    components: {
        TooliabaButton,
        ImageLabel
    },
    data: function() {
        return {
            search: ''
        };
    },
    methods: {
        submit() {
            this.$router.push({ path: '/search', query: { q: this.search } });
        }
    },
    computed: {
        lg() {
            return this.$mq === 'lg';
        }
    }
};
</script>
